import React from 'react';
  
function StreamConfiguration (){
    return <h1>Coming Soon</h1>
}
  
export default StreamConfiguration;